<template>
  <div class="credit-table">
    <v-data-table
      :footer-props="{
        'items-per-page-text': 'Số dữ liệu mỗi trang',
        'items-per-page-options': [10, 20, 50]
      }"
      disable-sort
      :headers="headers"
      :items="studentCreditReports"
      :loading="filterLoading"
      :items-per-page="itemsPerPage"
      no-data-text="Không có dữ liệu"
    >
      <template v-slot:[`item.student`]="{ item }">
        <card-student-name :student="item.student || {}" link />
      </template>
      <template v-slot:[`item.dob`]="{ item }">
        {{ moment(item.student.dob || '').format('DD/MM/YYYY') }}
      </template>
      <template v-slot:[`item.totalIn`]="{ item }">
        {{ Number(item.totalIn || 0).toLocaleString('en-US') }}
      </template>
      <template v-slot:[`item.totalInIsCounted`]="{ item }">
        {{ Number(item.totalInIsCounted || 0).toLocaleString('en-US') }}
      </template>
      <template v-slot:[`item.actions`]="{ item }">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <div v-on="on" v-bind="attrs" class="d-inline-flex cursor-pointer">
              <v-icon @click="() => navigateToCreditDetail(item)" size="20" class="ml-2" color="primary"
                >mdi-eye</v-icon
              >
            </div>
          </template>
          <span class="white--text text-justify">
            {{ 'Xem hoạt động sử dụng xu' }}
          </span>
        </v-tooltip>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { get } from 'lodash'
import CardStudentName from '@/components/basic/card/CardStudentName.vue'
import { mapActions, mapState } from 'vuex'
import moment from 'moment'
export default {
  props: {
    filterLoading: {
      type: Boolean,
      default: false
    }
  },
  components: { CardStudentName },
  computed: {
    ...mapState({
      studentCreditReports(state) {
        return state['studentCredit'].studentCreditReports.map((v, i) => ({
          ...v,
          index: i + 1,
          currentClass: get(v, 'currentClass.title', '')
        }))
      }
    })
  },
  created() {
    if (!this.$auth.policies['view-detail-student-credit-report']) {
      this.headers = this.headers.filter(v => v.value !== 'actions')
    }
  },
  data() {
    return {
      headers: [
        { text: 'STT', value: 'index', align: 'center', width: '40px' },
        { text: 'Học sinh', value: 'student' },
        { text: 'Lớp', value: 'currentClass', width: '120px' },
        { text: 'Ngày sinh', value: 'dob', width: '150px' },
        { text: 'Tổng nạp', value: 'totalIn', width: '120px', align: 'end' },
        { text: 'Đã sử dụng', value: 'totalInIsCounted', width: '120px', align: 'end' },
        { text: 'Thao tác', value: 'actions', width: '80px', align: 'center' }
      ],
      itemsPerPage: 10,
      page: 1,
      get,
      moment
    }
  },
  methods: {
    ...mapActions({
      fetchStudentCreditIndependent: 'studentCredit/fetchStudentCreditIndependent'
    }),
    async navigateToCreditDetail(item) {
      this.$loading.active = true
      try {
        const student = get(item, 'student.id')
        if (student) {
          const res = await this.fetchStudentCreditIndependent({ student })
          const creditId = res[0].id
          this.$router.push(`/student-credit/${creditId}`)
        }
      } catch (error) {
        this.$alert.error('Có lỗi xảy ra')
      } finally {
        this.$loading.active = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.credit-table {
  border: 1px solid rgba(0, 0, 0, 0.1);
}
</style>
